<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'addToastAction'
    ]),
    addToast (type, content, title) {
      let data = {
        type: type,
        title: title,
        content: content
      }
      this.addToastAction(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/toastMethods.vue